import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      meta: { requiresAuth: true},
      component: () => import('@/views/Index.vue'),
    },
    {
      path: '/login',
      meta: { noMenu: true },
      component: () => import('@/views/Login/Form.vue'),
    },
    {
      path: '/batches',
      meta: { requiresAuth: true },
      component: () => import('@/views/Batches/List.vue'),
    },
    {
      path: '/presettags',
      meta: { requiresAuth: true },
      component: () => import('@/views/Presettags/List.vue'),
    },
    {
      path: '/products',
      meta: { requiresAuth: true },
      component: () => import('@/views/Products/List.vue'),
    },
    {
      path: '*',
      component: () => import('@/views/Error/Index.vue'),
    },
  ],
});
